import { c as _c } from "react/compiler-runtime";
import { IcoClock16 } from '@onefootprint/icons';
import type { CreateEntityTokenResponse } from '@onefootprint/request-types/dashboard';
import { CopyButton, TextInput } from '@onefootprint/ui';
import { formatDistanceToNowStrict } from 'date-fns';
import { useTranslation } from 'react-i18next';
type LinkDisplayProps = {
  title: string;
  description: string;
  linkData: Pick<CreateEntityTokenResponse, 'link' | 'expiresAt'>;
};
const LinkDisplay = t0 => {
  const $ = _c(21);
  const {
    title,
    description,
    linkData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "actions.linkDisplay"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== title) {
    t2 = <div className="text-label-2 text-primary">{title}</div>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <div className="text-body-2 text-secondary">{description}</div>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== linkData.link) {
    t4 = <CopyButton contentToCopy={linkData.link} className="hover:!bg-senary/40 active:!bg-senary/40" />;
    $[5] = linkData.link;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== linkData.link || $[8] !== t4) {
    t5 = <TextInput placeholder="https://verify.onefootprint.com#tok_okj3nppo1zyj6d7uJ9l49iLxY1uc2N4riz" value={linkData.link} size="compact" disabled={true} className="!whitespace-nowrap !overflow-hidden !text-ellipsis" suffixComponent={t4} />;
    $[7] = linkData.link;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IcoClock16 color="quaternary" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== linkData.expiresAt || $[12] !== t) {
    t7 = t(_temp, {
      duration: formatDistanceToNowStrict(new Date(linkData.expiresAt))
    });
    $[11] = linkData.expiresAt;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="flex gap-1">{t6}<div className="text-caption-4 text-quaternary">{t7}</div></div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t5 || $[19] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t2}{t3}{t5}{t8}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default LinkDisplay;
function _temp($) {
  return $.expiresIn;
}